import { JustificationValidationStatus } from "@/entities/attendanceEvent/AttendanceEventType"

interface Props {
   selectedStatus: JustificationValidationStatus | "all"
   setSelectedStatus: (status: JustificationValidationStatus | "all") => void
}

export function AttendanceEventFilterBar({ selectedStatus, setSelectedStatus }: Props) {
   return (
      <div className="filter-bar">
         <span className="label">Statut </span>

         <button
            className={`btn btn-sm ${selectedStatus === "all" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("all")}
         >
            Tous
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "upload_pending" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("upload_pending")}
         >
            À justifier
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "admin_pending" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("admin_pending")}
         >
            En attente
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "validated" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("validated")}
         >
            Validé
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "rejected" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("rejected")}
         >
            Refusé
         </button>
      </div>
   )
}
